import DevWeb from './img/DevWeb.png'
import Designer from './img/Designer.png'
import DevMobile from './img/DevMobile.png'
import Full from './img/full.png'
import Video from './img/Video.png'
import Guia from './img/Guia.png'

const SsData = [
  {
    title: 'Desenvolvimento Full Stack',
    src: Full,
    desc: 'Fiz alguns cursos, tanto para Front-End quanto para Back-End, trabalhei com ReactJS, React Native, Ruby on Rails, Firebase.',
  },
  {
    title: 'Desenvolvimento Web',
    src: DevWeb,
    desc: 'Fiz alguns cursos, trabalho diariamente com ReactJS.',
  },
  {
    title: 'Desenvolvimento Mobile',
    src: DevMobile,
    desc: 'Fiz alguns cursos, trabalho diariamente com React Native.',
  },
  {
    title: 'Designer',
    src: Designer,
    desc: 'Fiz alguns cursos de Photoshop, CorelDraw, algumas artes, cartões de visita, folders e banners.',
  },
  {
    title: 'Edição de Vídeos',
    src: Video,
    desc: 'Como gosto muito de viajar, tirar fotos, gravar vídeos, aprendi a fazer algumas edições legais, cheguei a fazer algumas gravações de Drone.',
  },
  {
    title: 'Guia de Turismo',
    src: Guia,
    desc: 'Estou finalizando o curso técnico, em breve terei meu app de turismo para mostrar as belezas naturais do nosso Brasil e os futuros passeios.',
  },

]
export default SsData
